import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Auth } from 'aws-amplify';
import { environment } from '../../../environment/environment';
import { AuthService } from '../../services/auth.service';
import { fallIn, moveIn } from '../../router.animations';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { User } from '../../models/user';

@Component({
  selector: 'ozm-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss'],
  animations: [moveIn(), fallIn()],
  host: { '[@moveIn]': '' }
})

export class SignupComponent implements OnInit {
  UserForm: FormGroup;

  user: User | undefined;
  isConfirm: boolean = false;
  alertMessage: string = '';
  showAlert: boolean = false;
 
  res_data: any;
  user_data: any;
  msg='';
  submitted: boolean = false;
  get_otp: boolean =false;

  constructor(
    private _router: Router, 
    private _authService: AuthService
  ) {}

  ngOnInit(): void {
    if (this._authService.accessToken) {
      this._router.navigate(['']);
    } else {
      this.user = {} as User;
      this.isConfirm = false;
      this.createForm();
    }
  }

  public async signUpithCognito() {
    try {
      // Validate form before submission
      if (!this.UserForm.valid) {
        this.displayAlert('Please fill in all required fields correctly');
        return;
      }

      // Validate user data
      if (!this.user?.email || !this.user?.pass || !this.user?.name) {
        this.displayAlert('Email, password, and name are required');
        return;
      }

      console.log('User data for signup:', {
        email: this.user.email,
        name: this.user.name,
        phone: this.user.phone
      });
      
      this.submitted = true;
      this.msg = '';
      
      try {
        // ✅ Try direct signup first
        const signUpResult = await this._authService.signUp(this.user); 
        console.log('Direct signup successful:', signUpResult);
        
        // If successful, set confirm mode
        this.isConfirm = true;
        this.displayAlert('Please check your email for verification code');
        
      } catch (directSignupError: any) {
        console.error('Direct signup failed:', directSignupError);
        
        // If direct signup fails due to OAuth configuration, redirect to Cognito Hosted UI
        if (directSignupError.code === 'NotAuthorizedException' || 
            directSignupError.message.includes('unauthorized attribute') ||
            directSignupError.message.includes('OAuth-only')) {
          
          console.log('Redirecting to Cognito Hosted UI for signup');
          this.msg = 'Redirecting to secure signup page...';
          
          // Redirect to Cognito Hosted UI signup page
          setTimeout(() => {
            window.location.href = `https://${environment.cognitoConfig.oauth.domain}/signup?response_type=code&client_id=${environment.cognitoConfig.userPoolWebClientId}&redirect_uri=${environment.cognitoConfig.oauth.redirectSignIn}`;
          }, 1000);
          
        } else {
          // Handle other specific error types
          throw directSignupError;
        }
      }

    } catch (error: any) {
      console.error('Signup error:', error);
      this.submitted = false;
      
      // Handle specific error types
      if (error.code === 'UsernameExistsException') {
        this.msg = 'An account with this email already exists';
      } else if (error.code === 'InvalidPasswordException') {
        this.msg = 'Password does not meet requirements';
      } else if (error.code === 'InvalidParameterException') {
        this.msg = 'Invalid input parameters. Please check your information.';
      } else if (error.code === 'NotAuthorizedException') {
        this.msg = 'Unable to create account. Redirecting to secure signup...';
        // Also redirect to Cognito Hosted UI as fallback
        setTimeout(() => {
          window.location.href = `https://${environment.cognitoConfig.oauth.domain}/signup?response_type=code&client_id=${environment.cognitoConfig.userPoolWebClientId}&redirect_uri=${environment.cognitoConfig.oauth.redirectSignIn}`;
        }, 2000);
      } else {
        this.msg = error.message || 'Registration failed. Please try again.';
      }
      
      this.displayAlert(this.msg);
    }
  }

  // public confirmSignUp() {
  //   if(this.user) {
  //     this._authService.confirmSignUp(this.user)
  //     .then(() => {
  //       console.log("success full login");
  //       this._router.navigate(["/"])
  //     })
  //     .catch((error: any) => {
  //       this.msg = error.message;
  //       // this.displayAlert(error.message);
  //     })
  //   } else {
  //     this.displayAlert("Missing user info")
  //   }
  // }

    public async confirmSignUp() {
      try {
    if(this.user) {
      const isSuccess = await this._authService.confirmSignUp(this.user)
      console.log('%%%%%%%%%%%%%%%%');
      console.log(isSuccess)
      if(isSuccess) {
        const user = await this._authService.signIn(this.user.email, this.user.pass);
        //retrieve and store access token
      const session = await Auth.currentSession();
      const accessToken = session.getAccessToken().getJwtToken();
      const idToken = session.getIdToken().getJwtToken();

      this._authService.accessToken = accessToken;
      this._authService.idToken = idToken;

      console.log('SignUpToken: \n' + this._authService.accessToken);
      // Redirect to the home page (adjust the route as needed)
      this._router.navigate(['']);
      }

      
    }} catch(error: any) {
        this.msg = error.message;
        // this.displayAlert(error.message);
      }
    } 
  

  



  private displayAlert(message: string) {
    this.alertMessage = message;
    this.showAlert = true;
  }

  createForm() {
    this.UserForm = new FormGroup({
      name: new FormControl(this.user.name, [Validators.required]),
      email: new FormControl(this.user.email, [Validators.required]),
      phone: new FormControl(this.user.phone, [Validators.required,Validators.pattern("^((\\+91-?)|(\\+1)|0)?[0-9]{10}$") ]),
      pass: new FormControl(this.user.pass, [Validators.required ]),
    });
  }


  // Alternative method: Go directly to Cognito Hosted UI
  redirectToHostedUISignup() {
    console.log('Redirecting directly to Cognito Hosted UI signup');
    window.location.href = `https://${environment.cognitoConfig.oauth.domain}/signup?response_type=code&client_id=${environment.cognitoConfig.userPoolWebClientId}&redirect_uri=${environment.cognitoConfig.oauth.redirectSignIn}`;
  }

  async onSubmit() {
    try {
      // Validate form before submission
      if (!this.UserForm.valid) {
        this.displayAlert('Please fill in all required fields correctly');
        return;
      }

      // Validate user data
      if (!this.user?.email || !this.user?.pass || !this.user?.name) {
        this.displayAlert('Email, password, and name are required');
        return;
      }

      console.log('User data for signup:', {
        email: this.user.email,
        name: this.user.name,
        phone: this.user.phone
      });
      
      this.submitted = true;
      this.msg = '';
      
      try {
        // ✅ Try direct signup first
        const signUpResult = await this._authService.signUp(this.user); 
        console.log('Direct signup successful:', signUpResult);
        
        // If successful, redirect to the Cognito Hosted UI for verification
        window.location.href = `https://${environment.cognitoConfig.oauth.domain}/signup?response_type=code&client_id=${environment.cognitoConfig.userPoolWebClientId}&redirect_uri=${environment.cognitoConfig.oauth.redirectSignIn}`;
        
      } catch (directSignupError: any) {
        console.error('Direct signup failed:', directSignupError);
        
        // If direct signup fails due to OAuth configuration, redirect to Cognito Hosted UI
        if (directSignupError.code === 'NotAuthorizedException' || 
            directSignupError.message.includes('unauthorized attribute') ||
            directSignupError.message.includes('OAuth-only')) {
          
          console.log('Redirecting to Cognito Hosted UI for signup');
          this.displayAlert('Redirecting to secure signup page...');
          
          // Redirect to Cognito Hosted UI signup page
          setTimeout(() => {
            window.location.href = `https://${environment.cognitoConfig.oauth.domain}/signup?response_type=code&client_id=${environment.cognitoConfig.userPoolWebClientId}&redirect_uri=${environment.cognitoConfig.oauth.redirectSignIn}`;
          }, 1000);
          
        } else {
          // Handle other specific error types
          throw directSignupError;
        }
      }

    } catch (error: any) {
      console.error('Signup error:', error);
      this.submitted = false;
      if (error.code === 'UsernameExistsException') {
        this.msg = 'An account with this email already exists';
      } else if (error.code === 'InvalidPasswordException') {
        this.msg = 'Password does not meet requirements';
      } else if (error.code === 'InvalidParameterException') {
        this.msg = 'Invalid input parameters. Please check your information.';
      } else if (error.code === 'NotAuthorizedException') {
        this.msg = 'Unable to create account. Redirecting to secure signup...';
        // Also redirect to Cognito Hosted UI as fallback
        setTimeout(() => {
          window.location.href = `https://${environment.cognitoConfig.oauth.domain}/signup?response_type=code&client_id=${environment.cognitoConfig.userPoolWebClientId}&redirect_uri=${environment.cognitoConfig.oauth.redirectSignIn}`;
        }, 2000);
      } else {
        this.msg = error.message || 'Registration failed. Please try again.';
      }
      
      this.displayAlert(this.msg);
    }
  }

}


//https://www.youtube.com/watch?v=20MKg4tAejg